import React from 'react'
import './KvRow.css'

const isEmpty = (value) => value === null || value === undefined || value === ''

const KvRowUI = ({ className, label, value, children, emphasis, onEdit, hideWhenEmpty, emptyLabel = '—' }) => {
  if (hideWhenEmpty && isEmpty(value) && !children) return null

  return (
    <div className={`w_kv_row ${className ? className : ''}`}>
      <span className='w_kv_label'>
        {label}
        {
          onEdit &&
          <span className='icon icon-pencil g_link_2 g_m_left_25' onClick={onEdit} />
        }
      </span>
      <span className={`w_kv_value ${emphasis ? 'emphasis' : ''}`}>
        {children || (isEmpty(value) ? emptyLabel : value)}
      </span>
    </div>
  )
}

const KvSectionUI = ({ className, label }) =>
  <div className={`w_kv_section ${className ? className : ''}`}>{label}</div>

const KvSummaryUI = ({ className, items }) =>
  <div className={`w_kv_summary ${className ? className : ''}`}>
    {
      items.map((item, i) =>
        <div key={i} className='w_kv_summary_item'>
          <span className='w_kv_summary_label'>{item.label}</span>
          <span className='w_kv_summary_value'>{item.value || '—'}</span>
        </div>
      )
    }
  </div>

export { KvRowUI, KvSectionUI, KvSummaryUI }
export default KvRowUI
